"use strict";

var _cuid = _interopRequireDefault(require("cuid"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.createMessage = createMessage;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function createMessage(a) {
  return {
    id: (0, _cuid.default)(),
    type: a.type,
    payload: a.payload
  };
}